import React from 'react';
import errImage from '../assets/images/error.svg';
import styled from 'styled-components';
export const ErrorPage = () => {
    const reloadOnClick = () => {
        localStorage.clear();
        window.location.reload();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: 'calc(100vh - 120px)',
            } },
            React.createElement("div", { style: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '100%',
                    maxWidth: '600px',
                    fontFamily: 'Arial, sans-serif',
                } },
                React.createElement("img", { style: { maxWidth: '80%' }, src: errImage }),
                React.createElement("h1", null,
                    "Something went wrong. Please try again. If the problem persists, please contact support",
                    ' ',
                    React.createElement("a", { href: "https://debbie.zendesk.com/hc/da/requests/new" }, "here"),
                    "."),
                React.createElement(Button, { type: "button", value: "Try again", onClick: reloadOnClick })))));
};
const Button = styled.input `
  width: 100%;
  padding: 10px 20px;
  margin-top: 20px;
  font-size: 16px;
  font-weight: bold;
  background-color: #200d54;
  color: #fff;
  border: none;
  cursor: pointer;

  &:hover {
    background-color: #2c0f7f;
  }
`;
//# sourceMappingURL=ErrorPage.js.map